<template>
  <div>
    <PageHeader title="Unsubscribe"></PageHeader>
    <div v-if="!isLoggedIn">
      <p>
        Please log in to your account to change your email preferences. Once logged in go to your profile to do so.
      </p>
      <p>
        <router-link :to="{name: 'login'}">Log in</router-link>
      </p>
    </div>
    <div v-if="isLoggedIn">
      <p>
        Please go to your profile to update your email preferences.
      </p>
      <p>
        <router-link :to="{name: 'profile'}">Go to profile</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'logout',
  components: {
    PageHeader
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn;
    }
  }
}
</script>